<template>
<div id="app">
    <FormulateForm class="login-form"
    v-model="formValues"
    @submit="submitForm"
    >
    <div class="back-button-container">
      <router-link to="/helper" class="back-button">
        <svg class="back-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="back-text">返回</span>
      </router-link>
    </div>
    <div class="form-container2">
    <h3>1.整體而言，對於今天使用 FHR APP的體驗，您的滿意度為何？</h3>
    <FormulateInput
    name="satisfaction"
    :options="{1: '非常滿意', 2: '有點滿意',3: '一般',4: '有點不滿意',5: '非常不滿意'}"
    type="radio"
    validation="required"
    />

    <h3>2.您今天使用了哪項功能?</h3>
    <FormulateInput
    v-model="feature_array"
    :options="{1: '影像分享/接收', 2: '儲存CD光碟影像', 3: '檢查影像瀏覽', 4:'其他'}"
    type="checkbox"
    class="nomargin"
    validation="required"
    ignored
    />
    <FormulateInput
        v-if="feature_array[0] === '4'||feature_array[1] === '4'||feature_array[2] === '4'||feature_array[3] === '4'"
        type="text"
        help="其他"
        name="featureOther"
        />

    <h3>3.您今日的使用目的是？</h3>
    <FormulateInput
    name="purpose"
    :options="{1: '自身健康維護', 2: '家人健康維護', 3: '病人診療協助', 4:'其他'}" 
    type="radio"
    class="nomargin"
    validation="required"
    
    />
    <FormulateInput
        v-if="formValues.purpose === '4'"
        type="text"
        help="其他"
        name="purposeOther"
        />
    <h3>4. 您使用的裝置是？</h3>
    <FormulateInput
    name="device"
    :options="{1: 'iOS', 2: 'Android', 3: '其他'}"
    type="radio"
    class="nomargin"
    validation="required"
    />
    <FormulateInput
        v-if="formValues.device === '3'"
        help="其他"
        type="text"
        name="deviceOther"
        />
    <h3>您期望FHR增加哪方面的服務，以及建議？請留下您的聯絡資訊，以利回覆。謝謝！</h3>
    <FormulateInput
        type="textarea"
        name="suggestion"
        validation="max:256"
        error-behavior="live"
        />
        <FormulateInput
        type="text"
        name="name"
        label="姓 名"
        />
        <FormulateInput
        type="email"
        name="email"
        label="Email ID"
        />
        <FormulateInput
        type="number"
        name="telephone"
        label="電 話"
        />
    <FormulateInput
        type="submit"
        name="送出"
    />
    </div>
    </FormulateForm>  
    <v-snackbar
      v-model="snackbar"
    >
      Form submitted successfully. Thank you.
    </v-snackbar>
</div>
</template>
<script>
import axios from 'axios'
export default {
  metaInfo() {
        return { 
            title: "FHR",
            meta: [
                { name: 'description', content:  'A Viewer Ready DICOM Device.'},
            ]
        }
    },
  data () {
    return {
      snackbar:false,
      feature_array:[], //taking a temporary arr to store feature on string with commas
      formValues: {
        feature:'',
        createDate: '',
        deviceOther:null,
        purposeOther: null,
        featureOther: null,
        suggestion:null,
        name: null,
        email:null,
        telephone:null
      }
    }
  },
  created(){
    window.scrollTo(0, 0); //scroll to page top
  },
  methods:{
      submitForm(){
        //getting value for createDate
        const saveDate = new Date();
        let month =saveDate.getMonth();
        let date = saveDate.getDate();
        let hours = saveDate.getHours();
        let minutes = saveDate.getMinutes();
        let seconds = saveDate.getSeconds();
        month++;
        month = ("0" + month).slice(-2);
        date = ("0" + date).slice(-2);
        hours = ("0" + hours).slice(-2);
        minutes = ("0" + minutes).slice(-2);
        seconds = ("0" + seconds).slice(-2);
        this.formValues.createDate = saveDate.getFullYear()+ "-" + month+ '-'+ date+'T'+ hours+':'+ minutes+':'+ seconds
        //vue-formulate auto parses the sequence so changing inorder to show ui correctly
        switch (this.formValues.satisfaction) {
          case '1':
            this.formValues.satisfaction='5';
            break;
          case '2':
            this.formValues.satisfaction='4';
            break;
          case '4':
            this.formValues.satisfaction='2';
            break;
          case '5':
            this.formValues.satisfaction='1';
            break;
        }
        console.log("form",this.formValues);
        //feature is sroted in array format so changing to string format
        let arr = this.feature_array;
        this.formValues.feature= arr.join();
        //calling post request to api 
        axios.post('https://fhrweb.ebmtech.com/net/api/Questionnaires',this.formValues)
          .then(this.$router.push("/helper")
          )
          .catch(error=>{
            console.log(error);
          })
          this.snackbar = true
        alert('Thank you for your feedback!')
      }
  }
}
</script>
<style scoped>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 20px;
} */
#app {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111827;
  background-color: #EDEFF4;
  min-height: 100vh;
  padding: 20px 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.title{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
h3{
  margin-top: 1em;
  margin-bottom: 1em;
}
.login-form {
  margin: 0.5em;
  padding: 0px;
  /* border: 1px solid #a8a8a8; */
  border-radius: .5em;
  margin: auto;
  width: 100%;
  box-sizing: border-box;
}

.nomargin{
  margin-bottom: 0px;
}
.form-title {
  margin-top: 0;
}
.login-form::v-deep .formulate-input .formulate-input-element--textarea{
  max-width: none;
}
.back-button-container {
  margin-bottom: 20px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #FFFFFF;
  color: #000000;
  text-decoration: none;
  border-radius: 50px;
  font-weight: 400;
  font-size: 16px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.back-button:hover {
  box-shadow: 0 4px 12px rgba(36, 36, 36, 0.4);
  text-decoration: none;
}


.back-icon {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}

.back-button:hover .back-icon {
  transform: translateX(-2px);
}

.back-text {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.floatleft{
  width: 25px;
}
.form-container2 {
  background-color: #FFFFFF;
  border-radius: 14px;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  /* max-width: 600px; */
}
</style>